// loadUrlOrderProcessing.js
'use strict';
import {
  SHOP_ID,
  orderStatusConstant,
  orderStatusWhiteList,
} from '../resource/shopConstants.js';
import getMeData from '../selector/getMeData.js';
import subscribePresenceOrder from '../action/subscribePresenceOrder.js';
import { ADD_ORDERS } from '../ActionTypes.js';

/**
 * Load url order processing
 * @kind action
 * @param {URL} {url} - url to load.
 * @param {string} {pathname} - new pathname after read url.
 * @return {Promise} Action promise.
 */
const loadUrlOrderProcessing =
  ({ url, pathname }) =>
  async (dispatch, getState) => {
    let shopId = url.searchParams.get('shopId');
    const action =
      url.searchParams.get('action') || url.searchParams.get('act');
    if (action === 'prepaid' && !shopId) {
      shopId = SHOP_ID.addvalue;
    }
    if (!shopId) {
      return { type: '' };
    }

    const token = getMeData(getState(), 'token');
    if (token) {
      // non-logged in user will execute prepaid query action flow after flight-check.
      history.replaceState(
        null,
        '',
        pathname || `${url.origin}${url.pathname}`
      );
    }

    let orderStatus = url.searchParams.get('status');
    if (!orderStatusWhiteList.includes(orderStatus)) {
      orderStatus = orderStatusConstant.PENDING;
    }

    const orderId = url.searchParams.get('order'); // avoid eslint require-atomic-updates error
    if (token) {
      dispatch({
        type: ADD_ORDERS,
        payload: {
          orders: {
            [orderId]: {
              id: orderId,
              shopId,
              subscribeUserId: url.searchParams.get('subscribeUserId'),
              email: url.searchParams.get('email'),
              status: orderStatus,
              sources: [{ id: url.searchParams.get('sourceId') }],
            },
          },
        },
      });
      dispatch(
        subscribePresenceOrder({
          orderId,
          shopId,
        })
      );
    }
  };

export default loadUrlOrderProcessing;
